import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { AccountSettingsStoreSlice } from './types';
import {
  initBrowsingPage,
  initDeactivationStatus,
  initMyAccountPage,
  initNotificationsPage,
  initPersonalDataPage,
  initPromosPage,
  initSecurityPage,
} from './actions';
import {
  defaultMyAccountState,
  defaultBrowsingState,
  defaultSecurityState,
  defaultNotificationsState,
  defaultPromosState,
  defaultPersonalDataState,
  defaultDeactivationState,
} from './defaults';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

function mergeDefaultPageState<T extends object | undefined>(
  defaultState: T,
  action: { payload: { data: T } }
): T {
  return {
    ...defaultState,
    ...omitBy(action.payload.data, isUndefined),
  };
}

const reducers = handleActions<AccountSettingsStoreSlice, any>(
  {
    [initMyAccountPage.toString()]: (
      state,
      action: ReturnType<typeof initMyAccountPage>
    ) => ({
      ...state,
      myAccountPage: mergeDefaultPageState<
        AccountSettingsStoreSlice['myAccountPage']
      >(defaultMyAccountState, action),
    }),
    [initBrowsingPage.toString()]: (
      state,
      action: ReturnType<typeof initBrowsingPage>
    ) => ({
      ...state,
      browsingPage: mergeDefaultPageState<
        AccountSettingsStoreSlice['browsingPage']
      >(defaultBrowsingState, action),
    }),
    [initSecurityPage.toString()]: (
      state,
      action: ReturnType<typeof initSecurityPage>
    ) => ({
      ...state,
      securityPage: mergeDefaultPageState<
        AccountSettingsStoreSlice['securityPage']
      >(defaultSecurityState, action),
    }),
    [initNotificationsPage.toString()]: (
      state,
      action: ReturnType<typeof initNotificationsPage>
    ) => ({
      ...state,
      notificationsPage: mergeDefaultPageState<
        AccountSettingsStoreSlice['notificationsPage']
      >(defaultNotificationsState, action),
    }),
    [initPromosPage.toString()]: (
      state,
      action: ReturnType<typeof initPromosPage>
    ) => ({
      ...state,
      promosPage: mergeDefaultPageState<
        AccountSettingsStoreSlice['promosPage']
      >(defaultPromosState, action),
    }),
    [initPersonalDataPage.toString()]: (
      state,
      action: ReturnType<typeof initPersonalDataPage>
    ) => ({
      ...state,
      personalDataPage: mergeDefaultPageState<
        AccountSettingsStoreSlice['personalDataPage']
      >(defaultPersonalDataState, action),
    }),
    [initDeactivationStatus.toString()]: (
      state,
      action: ReturnType<typeof initDeactivationStatus>
    ) => ({
      ...state,
      deactivationStatus: {
        ...defaultDeactivationState,
        ...action.payload.status,
      },
    }),
  },
  {
    myAccountPage: undefined,
    browsingPage: undefined,
    securityPage: undefined,
    notificationsPage: undefined,
    promosPage: undefined,
    personalDataPage: undefined,
    deactivationStatus: undefined,
  }
);

export default {
  [reduxKey]: reducers,
};
